import React, { useEffect, useMemo, useState } from "react";
import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FSelect } from "@ui/components/inputs/FSelect";
import { toast } from "@ui/utils/toaster";
import { categoriesApi } from "@api/enpoints/categories-api";
import { apiErrorMessage } from "@api/enpoints/clients-api";
/** "Categories" of the node general settings: one node category for now. */
export const NodeCategoriesSection = ({ control, current }) => {
    const { t } = useTranslation(["common"]);
    const [options, setOptions] = useState([]);
    useEffect(() => {
        let active = true;
        categoriesApi
            .getOptions("node")
            .then((response) => { var _a; return active && setOptions(((_a = response.data.data) !== null && _a !== void 0 ? _a : []).map((c) => ({ value: c.id, label: c.name }))); })
            .catch((error) => toast.error(apiErrorMessage(error, t("common:catalog.node.categoriesFailed", "Could not load the node categories."))));
        return () => {
            active = false;
        };
    }, [t]);
    const seeded = useMemo(() => (current !== null && current !== void 0 ? current : []).map((c) => ({ value: c.id, label: c.name })), [current]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { variant: "h4", sx: { color: "primary.darker" } }, t("common:catalog.categories.title", "Categories")),
        React.createElement(Grid, { container: true, spacing: 1.5, sx: { mb: 2 } },
            React.createElement(Grid, { size: { xs: 12, md: 4 } },
                React.createElement(FSelect, { name: "nodeCategoryId", control: control, label: t("common:catalog.categories.categoryLabel", "Category"), options: options.length > 0 ? options : seeded })))));
};
